<template>

<core-content-wrapper 
	:empty="is.ready && !totalMaxResults" 
	:noResults="is.ready && totalMaxResults && !totalResults" 
	:loading="!is.ready"
>

	<core-content-empty 
		v-if="is.ready && !totalMaxResults" 
		title="Oh dear, no ratings!" 
		text="It seems you have not rated any games yet." 
	/>
	
	<core-content-empty 
		v-if="is.ready && totalMaxResults && !totalResults" 
		title="Oh dear, no matches!" 
		text="Your filtering skills are too strong, try broadening the settings." 
	/>

	<com-filter 
		:loading="is.fetching" 
		:count="totalPseudoResults" 
		:nested="totalNestedResults" 
		:maximum="totalMaxResults" 
		v-show="totalMaxResults" 
		v-on:refresh="refresh" 
		v-if="is.ready" 
	/>
	
	<app-view 
		:data="content" 
		filter="ratings"
		view="config/ratings/layout"
		:has-more="currentPage < totalPages || (is.fetching && is.scrollLoading)"
		v-on:scroll="onScroll"
		v-if="is.ready" 
	/>

	<core-content-select noun="rating" />

</core-content-wrapper>

</template>

<script>

import Content from 'core/mixin/List.js'
import Filter from './ratings/Filter.vue'

export default {

	mixins: [Content],

	components: {

		'com-filter': Filter

	},

	data: function() {

		return {

			contentName: 'ratings',
			routeName: 'Ratings'

		}

	}

}

</script>

<style scoped>

</style>